import { Routes, Route } from "react-router-dom";
import Header from "./components/common/Header";
import Home from "./pages/Home";
import Game from "./pages/Game";
import Leaderboard from "./pages/Leaderboard";
import Replay from "./pages/Replay";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <div className="w-full h-full bg-board-bg pt-[72px]">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/game/:roomId" element={<Game />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/replay/:roomId" element={<Replay />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
